<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y v-if="user.role.roleName != 'FINANCE_MANAGER'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllStockIssue('printStockIssue')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockIssue()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex
              sm3
              v-if="
                user.role.roleName == 'ADMIN' ||
                  user.role.roleName == 'FINANCE_MANAGER'
              "
            >
              <v-select
                :items="warehouseList"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.warehouseId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="serialNo"
                label="PO No"
                type="text"
                v-model="queryParams.serialNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockIssueList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ props.item.warehouseName }}</td>
                <td>{{ props.item.wholeSaleIssueNo }}</td>
                <td>
                  {{ props.item.issueDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ props.item.issueNo }}</td>
                <td>{{ props.item.serialNo }}</td>
                <td>{{ props.item.reason }}</td>
                <td>{{ props.item.createdBy }}</td>
                <td>
                  <v-btn
                    color="primary"
                    @click.stop="reprintStockIssueInvoice(props.item.id)"
                    >REPRINT</v-btn
                  >
                </td>
                <td>
                  <v-btn
                    color="success"
                    @click.stop="exportExcel(props.item.id)"
                    >EXPORT</v-btn
                  >
                </td>
              </tr>
            </template>

            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.stockIssueItems"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.product.code }}</td>
                      <td class="text-xs">{{ subprops.item.product.name }}</td>
                      <td class="text-xs">
                        {{
                          subprops.item.productUnit.factor +
                            "/" +
                            subprops.item.productUnit.unitName
                        }}
                      </td>
                      <td class="text-xs">
                        {{ subprops.item.qty | decFormat(6) }}
                      </td>
                      <td class="text-xs">{{ subprops.item.qcNo }}</td>
                      <td class="text-xs">{{ subprops.item.batchNo }}</td>
                      <td class="text-xs">
                        {{ subprops.item.mfgDateInMilliSeconds | formatMsDate }}
                      </td>
                      <td class="text-xs">
                        {{ subprops.item.expDateInMilliSeconds | formatMsDate }}
                      </td>
                      <td class="text-xs">{{ subprops.item.remark }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <div
        id="printStockIssue"
        style="bsale: 1px solid black; width: 300px"
        v-show="false"
      >
        <div style="text-align: center">
          <p style="font-size: 18px; margin: 1px">Stock Issue Report</p>
        </div>
        <br />
        <div style="padding-left: 5px; padding-right: 5px">
          <table
            style="
              font-family: arial, sans-serif;
              border-collapse: collapse;
              width: 100%;
              font-size: 11px;
              border-top: 1px solid black;
            "
          >
            <thead
              style="
                border-bottom: 1px solid black;
                border-top: 1px solid black;
              "
            >
              <tr>
                <th style="text-align: left">Warehouse Name</th>
                <th style="text-align: left">WholeSale Invoice</th>
                <th style="text-align: left">Issue Date</th>
                <th style="text-align: left">Issue No</th>
                <th style="text-align: left">PO No</th>
                <th style="text-align: left">Reason</th>
                <th style="text-align: left">Created By</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in allStockIssueList" :key="index">
                <td>{{ item.warehouseName }}</td>
                <td>{{ item.wholeSaleIssueNo }}</td>
                <td>
                  {{ item.issueDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ item.issueNo }}</td>
                <td>{{ item.serialNo }}</td>
                <td>{{ item.reason }}</td>
                <td>{{ item.createdBy }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-layout>

    <!-- dialog -->
    <stockIssueExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></stockIssueExcel>
  </v-container>
</template>

<script>
import { stockIssueService } from "../../services/stockissue-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import stockIssueExcel from "../../components/stock-issue/stockIssueExcel";

export default {
  name: "StockIssueList",

  components: { stockIssueExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    openDialog: false,
    showFilters: false,
    issueDate: "",
    breadcrumbs: [
      {
        text: "Warehouse Management",
        disabled: true,
      },
      {
        text: "Stock Issue",
        disabled: true,
      },
    ],
    headers: [
      { text: "Warehouse Name", align: "left", value: "warehouse.name" },
      { text: "Whole Sale Invoice", align: "left", value: "wholeSaleIssueNo" },
      { text: "Issue Date", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "PO No", value: "serialNo" },
      { text: "Reason", value: "reason" },
      { text: "Created  By", value: "createdBy" },
      { text: "Reprint", align: "center", sortable: false },
      { text: "Export", align: "center", sortable: false },
    ],
    subHeaders: [
      { text: "Product Code", sortable: false },
      { text: "Product Name", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Qty", sortable: false },
      { text: "QC No", sortable: false },
      { text: "Batch No", sortable: false },
      { text: "MFG Date", sortable: false },
      { text: "EXP date", sortable: false },
      { text: "remark", sortable: false },
    ],
    printAllButtonLoading: false,
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0,
    },
    stockInStatusList: [
      { label: "---All---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    stockIssueList: [],
    allStockIssueList: [],
    warehouseList: [],
    totalRows: 0,
    queryParams: {
      warehouseId: "",
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      serialNo: "",
      updateUserId: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockIssueList();
      },
      deep: true,
    },
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (
      user.role.roleName == "WAREHOUSE_MANAGER" ||
      user.role.roleName == "WAREHOUSE_STAFF" ||
      user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.warehouseId = user.warehouseId;
      /*if (user.role.roleName == "WAREHOUSE_STAFF") {
        this.queryParams.updateUserId = user.id;
      }*/
    } else if (
      user.role.roleName == "PRODUCTION_MANAGER" ||
      user.role.roleName == "ASSET_MANAGER"
    ) {
      this.queryParams.warehouseId = this.user.shop.warehouseId;
    }
    //for deep linking
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.serialNo) {
      this.queryParams.serialNo = this.$route.query.serialNo;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.getStockIssueList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "stock-issues", query: this.queryParams });
      this.getStockIssueList();
    },
    dialogClose() {
      this.openDialog = false;
      this.getStockIssueList();
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStockIssueList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockIssueService
        .getStockIssueList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockIssueList = res.data.stockIssueList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/stock-issue/new");
    },
    printAllStockIssue(divName) {
      this.printAllButtonLoading = true;
      stockIssueService
        .getAllStockIssueList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allStockIssueList = res.data.stockIssueList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    reprintStockIssueInvoice(id) {
      stockIssueService.printStockIssueInvoice(id).then((res) => {
        var blob = res;
        commonService.showWindowDialog(blob, "invoice-" + id);
      });
    },
    exportAllStockIssue() {
      this.printAllButtonLoading = true;
      stockIssueService
        .exportAllStockIssueExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    exportExcel(id) {
      stockIssueService
        .exportStockIssueExcel(id)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
